// Re-ingreso offline: guarda un hash PBKDF2 (WebCrypto) de la contraseña del último
// usuario que inició sesión en este dispositivo. Nunca se guarda la contraseña en claro.
const KEY = 'freshen_offline_cred';
const ITER = 120000;

const toHex = (buf) => Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');

const derivar = async (password, saltHex) => {
  const enc = new TextEncoder();
  const salt = new Uint8Array(saltHex.match(/.{2}/g).map((h) => parseInt(h, 16)));
  const keyMat = await crypto.subtle.importKey('raw', enc.encode(password), 'PBKDF2', false, ['deriveBits']);
  const bits = await crypto.subtle.deriveBits({ name: 'PBKDF2', salt, iterations: ITER, hash: 'SHA-256' }, keyMat, 256);
  return toHex(bits);
};

export const guardarCredencialOffline = async (email, password, token, user) => {
  try {
    if (!crypto?.subtle) return;
    const saltHex = toHex(crypto.getRandomValues(new Uint8Array(16)));
    const hash = await derivar(password, saltHex);
    localStorage.setItem(KEY, JSON.stringify({ email: email.trim().toLowerCase(), salt: saltHex, hash, token, user, ts: new Date().toISOString() }));
  } catch { /* noop */ }
};

// Tras renovar el token, la credencial offline guarda el más reciente
export const actualizarTokenOffline = (token) => {
  try {
    const cred = JSON.parse(localStorage.getItem(KEY));
    if (cred) localStorage.setItem(KEY, JSON.stringify({ ...cred, token }));
  } catch { /* noop */ }
};

export const leerCredencialOffline = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

// Devuelve { token, user } si email+contraseña coinciden con el último usuario del dispositivo; null si no.
export const verificarCredencialOffline = async (email, password) => {
  const cred = leerCredencialOffline();
  if (!cred || !crypto?.subtle) return null;
  if (cred.email !== email.trim().toLowerCase()) return null;
  const hash = await derivar(password, cred.salt);
  return hash === cred.hash ? { token: cred.token, user: cred.user } : null;
};
